// extracted by mini-css-extract-plugin
export var link = "DefaultLink-module--link--1SQ8F";
export var icon = "DefaultLink-module--icon--3YWzV";
export var small = "DefaultLink-module--small--11uOa";
export var light = "DefaultLink-module--light--1rhRP";